import * as React from 'react';
import './styles/Capacidades.css';
import Timeline from '@mui/lab/Timeline';
import TimelineItem from '@mui/lab/TimelineItem';
import TimelineSeparator from '@mui/lab/TimelineSeparator';
import TimelineConnector from '@mui/lab/TimelineConnector';
import TimelineContent from '@mui/lab/TimelineContent';
// import TimelineOppositeContent from '@mui/lab/TimelineOppositeContent';
import TimelineDot from '@mui/lab/TimelineDot';
// import FastfoodIcon from '@mui/icons-material/Fastfood';
// import LaptopMacIcon from '@mui/icons-material/LaptopMac';
import Deploy_ from '../archivos/CapacidadesIcons/Deploy_.png';
import Desarrollo_ from '../archivos/CapacidadesIcons/Desarrollo_.png';
import Diseño_Interaccion from '../archivos/CapacidadesIcons/Diseño_Interaccion.png';
import Diseño_Producto from '../archivos/CapacidadesIcons/Diseño_Producto.png';
import Mantenimiento from '../archivos/CapacidadesIcons/Mantenimiento_.png';
import Typography from '@mui/material/Typography';
import { withTranslation } from 'react-i18next';

function Capacidades(props) {
	const { t, i18n } = props;
	return (
		<div id="Servicios" className='capacidadesContainer'>
			<h2>{t('Capacidades.titulo')}</h2>
			<Timeline position='alternate' style={{ zIndex: '10', padding: '2rem 0' }}>
				<TimelineItem className='seccionItem'>
					<TimelineSeparator>
						<TimelineConnector className='lineConnector' style={{ paddingTop: '2rem' }} />
						<TimelineDot style={{ backgroundColor: '#A71FE6', margin: 0 }}>
							<img className='imgItem' src={Diseño_Producto} alt='Icono de pluma' />
						</TimelineDot>
						<TimelineConnector className='lineConnector' />
					</TimelineSeparator>
					<TimelineContent sx={{ py: '20px', px: 2 }} className='itemContainer right'>
						<Typography variant='h6' component='span' className='itemTitle'>
							{t('Capacidades.DiseñoProducto')}
						</Typography>
						<Typography className='itemText'>{t('Capacidades.DiseñoProducto.p')}</Typography>
					</TimelineContent>
				</TimelineItem>
				<TimelineItem className='seccionItem'>
					<TimelineSeparator>
						<TimelineConnector className='lineConnector' />
						<TimelineDot style={{ backgroundColor: '#A71FE6', margin: 0 }}>
							<img className='imgItem' src={Diseño_Interaccion} alt='Icono de pantalla táctil' />
						</TimelineDot>
						<TimelineConnector className='lineConnector' />
					</TimelineSeparator>
					<TimelineContent sx={{ py: '20px', px: 2 }} className='itemContainer left'>
						<Typography variant='h6' component='span' className='itemTitle'>
							{t('Capacidades.DiseñoInteraccion')}
						</Typography>
						<Typography style={{ alignSelf: 'flex-end' }} className='itemText'>
							{t('Capacidades.DiseñoInteraccion.p')}
						</Typography>
					</TimelineContent>
				</TimelineItem>
				<TimelineItem className='seccionItem'>
					<TimelineSeparator>
						<TimelineConnector className='lineConnector' />
						<TimelineDot style={{ backgroundColor: '#A71FE6', margin: 0 }}>
							<img className='imgItem' src={Desarrollo_} alt='Icono de programación' />
						</TimelineDot>
						<TimelineConnector className='lineConnector' />
					</TimelineSeparator>
					<TimelineContent sx={{ py: '20px', px: 2 }} className='itemContainer right'>
						<Typography variant='h6' component='span' className='itemTitle'>
							{t('Capacidades.Desarrollo')}
						</Typography>
						<Typography className='itemText'>{t('Capacidades.Desarrollo.p')}</Typography>
					</TimelineContent>
				</TimelineItem>
				<TimelineItem className='seccionItem'>
					<TimelineSeparator>
						<TimelineConnector className='lineConnector' />
						<TimelineDot style={{ backgroundColor: '#A71FE6', margin: 0 }}>
							<img className='imgItem' src={Deploy_} alt='Icono de despegue' />
						</TimelineDot>
						<TimelineConnector className='lineConnector' />
					</TimelineSeparator>
					<TimelineContent sx={{ py: '20px', px: 2 }} className='itemContainer left'>
						<Typography variant='h6' component='span' className='itemTitle'>
							{t('Capacidades.Implementacion')}
						</Typography>
						<Typography style={{ alignSelf: 'flex-end' }} className='itemText'>
							{t('Capacidades.Implementacion.p')}
						</Typography>
					</TimelineContent>
				</TimelineItem>
				<TimelineItem className='seccionItem'>
					<TimelineSeparator>
						<TimelineConnector className='lineConnector' />
						<TimelineDot style={{ backgroundColor: '#A71FE6', margin: 0 }}>
							{/* <LaptopMacIcon /> */}
							<img className='imgItem' src={Mantenimiento} alt='Icono de engranaje' />
						</TimelineDot>
						<TimelineConnector className='lineConnector' style={{ paddingBottom: '2rem' }} />
					</TimelineSeparator>
					<TimelineContent sx={{ py: '20px', px: 2 }} className='itemContainer'>
						<Typography variant='h6' component='span' className='itemTitle'>
							{t('Capacidades.Mantenimiento')}
						</Typography>
						<Typography className='itemText'>{t('Capacidades.Mantenimiento.p')}</Typography>
					</TimelineContent>
				</TimelineItem>
			</Timeline>
		</div>
	);
}

export default withTranslation()(Capacidades);
